module.exports = __webpack_public_path__ + "img/step1-2.c3ed8087.png";